import Typography from "components/typography";
import React, { ReactElement } from "react";
import styled from "styled-components";
import { Colors } from "utils/colors";

interface Iprops {
  children?: React.ReactNode;
  title?: string;
  subtitle?: string;
  fullWidth?: boolean;
  headerButtonComponent?: ReactElement;
  OnClickButton?: () => void;
}
const GrayCard = ({
  title,
  subtitle,
  children,
  fullWidth = false,
  headerButtonComponent,
  OnClickButton
}: Iprops) => {
  return (
    <Container fullwidth={fullWidth}>
      <TitleContainer>
        <HeaderText>
          <Typography
            mb="1.6"
            weight="medium"
            size="2xl"
            color={Colors.white300}
          >
            {title}
          </Typography>
          <Typography
            mb="1.6"
            weight="medium"
            size="2xl"
            color={Colors.grey500}
          >
            {subtitle}
          </Typography>
        </HeaderText>
        {headerButtonComponent && (
          <Button
            onClick={() => {
              if (OnClickButton) {
                OnClickButton();
              }
            }}
          >
            {headerButtonComponent}
          </Button>
        )}
      </TitleContainer>
      <Body>{children}</Body>
    </Container>
  );
};

export default GrayCard;

const Container = styled.div<{ fullwidth?: boolean }>`
  border-radius: 0.8rem;
  background: ${Colors.grey700};
  padding: 2.4rem;
  margin-bottom: 2.4rem;
  margin-left: auto;
  margin-right: auto;
  width: ${(props) => (props.fullwidth ? "100%" : "55%")};
  @media only screen and (max-width: 769px) {
    width: 100%;
  }
`;

const HeaderText = styled.div`
  display: flex;
  align-items: center;
`;
const TitleContainer = styled.div`
  border-bottom: 0.5px solid ${Colors.grey600};
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const Button = styled.div`
  cursor: pointer;
`;

const Body = styled.div`
  width: 100%;
  padding-top: 2.4rem;
  @media only screen and (max-width: 769px) {
    overflow-x: scroll;
  }
`;
